<template>
  <div class="reports-sidebar">
    <div class="reports-sidebar-section">
      <h1>Filtros</h1>
    </div>
    <hr />
    <section class="reports-sidebar-section">
      <b-form-group>
        <label class="bold">Selecione uma equipe:</label>
        <b-form-select>
          <option
            v-for="(group, index) in groups"
            :key="`group_${index}`"
            :value="group._id"
          >
            {{ group.name }}
          </option>
        </b-form-select>
      </b-form-group>
    </section>
    <br />
    <section class="reports-sidebar-section">
      <p>Acesso rápido equipes:</p>
      <ul>
        <li class="clickable">Grupo A</li>
        <li class="clickable">Grupo B</li>
        <li class="clickable">Grupo C</li>
      </ul>
    </section>
    <hr />
    <section class="reports-sidebar-section">
      <h2>Atributos Inteligentes</h2>
      <b-form-group>
        <label>Gênero:</label>
        <b-form-select>
          <option>Feminino</option>
          <option>Masculino</option>
        </b-form-select>
      </b-form-group>
      <b-form-group>
        <label>Tempo de Casa:</label>
        <b-form-select>
          <option>Tempo de Casa - Até 1 ano</option>
          <option>Tempo de Casa - De 1 à 5 anos</option>
          <option>Tempo de Casa - De 5 à 10 anos</option>
          <option>Tempo de Casa - Mais de 10 anos</option>
        </b-form-select>
      </b-form-group>
      <b-form-group>
        <label>Geração:</label>
        <b-form-select>
          <option>Geração - X</option>
          <option>Geração - Y</option>
          <option>Geração - Z</option>
          <option>Geração - Todinho</option>
          <option>Geração - Nutella</option>
        </b-form-select>
      </b-form-group>
    </section>
    <hr />
    <section class="reports-sidebar-section">
      <h2>Membros</h2>
      <div class="group-member mt-3">
        <p>
          José Ricardo da Silva
          <small class="float-right text-secondary">Gestor</small>
          <small class="text-gray02">jose.ricardo@acme.com</small>
        </p>
      </div>
      <!-- <div class="group-member mt-3">
        <p>
          José Ricardo da Silva
          <small class="float-right text-secondary">Gestor</small>
          <small class="text-gray02">jose.ricardo@acme.com</small>
        </p>
      </div> -->
      <div class="group-member mt-3">
        <p>
          José Ricardo da Silva
          <small class="float-right text-primary">Membro</small>
          <small class="text-gray02">jose.ricardo@acme.com</small>
        </p>
      </div>
      <!-- <div class="group-member mt-3">
        <p>
          José Ricardo da Silva
          <small class="float-right text-primary">Membro</small>
          <small class="text-gray02">jose.ricardo@acme.com</small>
        </p>
      </div>
      <div class="group-member mt-3">
        <p>
          José Ricardo da Silva
          <small class="float-right text-primary">Membro</small>
          <small class="text-gray02">jose.ricardo@acme.com</small>
        </p>
      </div> -->
      <div class="text-center">
        <small class="bold clickable">Mostrar Mais</small>
      </div>
    </section>
    <hr />
    <section class="reports-sidebar-section text-center">
      <b-button variant="secondary" class="clean-filter-btn">
        Limpar Filtros
      </b-button>
    </section>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      resources: 'resources',
    }),
    labels() {
      return this.resources.page.home.customSurveys
    },
    groups() {
      return this.$store.getters['user/groupList']
    },
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
@import '~@/styles/custom/variables';
@import '~@/styles/custom/colors';

.reports-sidebar {
  width: 325px;
  padding: 15px;
  background-color: map-get($theme-colors, 'white');
  border-left: 1px solid var(--gray07) !important;

  .reports-sidebar-section {
    h1 {
      font-size: 1.7rem;
    }

    h2 {
      text-align: center;
      font-size: 1.25rem;
    }

    .clean-filter-btn {
      border-radius: 10px !important;
      min-width: 160px;
    }
  }
}
</style>
